module.exports = __webpack_public_path__ + "static/media/mess5.5972d393.png";